import { useTranslation } from 'react-i18next';
import { OutgoingSectionDto } from 'api/dtos/events/products';
import { useDeleteSectionMutation } from 'legacy/events/hooks';
import { useState } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import {
  TrashIcon,
  CheckmarkIcon
} from '../../../../../../../forms/TicketForm/components/icons';

interface EditSectionButtonProps {
  section: OutgoingSectionDto;
  onDelete: (sectionId: string) => void;
  deleteMutation: ReturnType<typeof useDeleteSectionMutation>;
  editSection: (sectionId: string, sectionName: string) => void;
  handleNameBlur: (sectionId: string) => Promise<void>;
  isSelected?: boolean;
}

const EditSectionButton = ({
  section,
  onDelete,
  deleteMutation,
  editSection,
  handleNameBlur,
  isSelected = false
}: EditSectionButtonProps) => {
  const { t } = useTranslation(['events']);
  const [isSaving, setIsSaving] = useState(false);

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    editSection(section.id, section.name || '');
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onDelete(section.id);
  };

  const handleSaveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsSaving(true);
    handleNameBlur(section.id).finally(() => {
      setIsSaving(false);
    });
  };

  if (isSelected) {
    return (
      <div className="flex items-center my-5 mx-4 gap-2 ">
        <button
          onClick={handleDeleteClick}
          type="button"
          className="group p-1 transition-colors"
          title={t('events:pricingTiers.accessibility.deleteSection')}
          aria-label={`${t('events:pricingTiers.accessibility.deleteSection')} ${section.name} section`}
        >
          <div className="group-hover:[&_path]:fill-red-500">
            {deleteMutation?.variables?.sectionId === section.id ? (
              <AiOutlineLoading3Quarters size={20} className="animate-spin" />
            ) : (
              <TrashIcon />
            )}
          </div>
        </button>

        <button
          onClick={handleSaveClick}
          type="button"
          disabled={isSaving}
          className="group p-1 transition-colors"
          aria-label={t('events:pricingTiers.accessibility.saveSectionName')}
        >
          {isSaving ? (
            <AiOutlineLoading3Quarters
              size={20}
              className="animate-spin text-black m-[2px]"
            />
          ) : (
            <div className="group-hover:[&_path]:fill-green-500">
              <CheckmarkIcon />
            </div>
          )}
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={handleEditClick}
      type="button"
      className="ml-4 mr-2 text-[#3853C4] text-base font-semibold"
      title={t('events:pricingTiers.accessibility.editSection')}
    >
      {t('events:pricingTiers.categories.edit')}
    </button>
  );
};

export default EditSectionButton;
